var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTheoryCostRate = function SvgTheoryCostRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF7836",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11v3.6a4 4 0 0 0-2.977 1.328 3.99 3.99 0 0 0-.966 3.351 4 4 0 0 0 1.973 2.803c-1.065.322-2.479.518-4.03.518-3.314 0-6-.895-6-2V11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11c0 1.105-2.686 2-6 2s-6-.895-6-2 2.686-2 6-2 6 .895 6 2M8 17.4c0 1.105 2.686 2 6 2 .723 0 1.416-.043 2.057-.12M8 14.2c0 1.105 2.686 2 6 2 1.103 0 2.136-.1 3.023-.272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18.6a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
  })))));
};
export default SvgTheoryCostRate;